import React from "react";
import ProductView from "./ProductView";

function ProductViewManage({ productid }) {
  
  return (
    <React.Fragment>
      <ProductView productid={productid} />
    </React.Fragment>
  );
}

export default ProductViewManage;
